import { Card, CardContent, CardDescription } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export const SkuPredictionSkeleton = () => (
  <div className='grid min-h-0 grid-cols-2 xl:grid-cols-3 gap-2 overflow-y-scroll'>
    {Array.from({ length: 4 }).map((_, index) => (
      <Card
        key={index}
        className='group relative aspect-square justify-between overflow-hidden'>
        <CardContent className='flex-1 size-full'>
          <Skeleton className='size-full rounded' />
        </CardContent>
        <CardDescription className='absolute inset-x-0 bottom-0 flex h-1/5 items-center justify-end bg-secondary/50'>
          <Skeleton className='h-3 w-8' />
        </CardDescription>
      </Card>
    ))}
  </div>
);
